import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  TOKEN: '/token2',
  LOGOUT: '/Logout'
};

export const loginRequest = (tcNumber, password,captchaToken) => {
  return axiosInstance.post(ENDPOINTS.TOKEN, {
    tcNumber,
    password,captchaToken
  });
};

export const logoutRequest = async (token) => {
  return axiosInstance.post(`${ENDPOINTS.LOGOUT}?token=${token}`, '', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

export const login = async (tcNumber, password,captchaToken) => {
  try {
    const response = await loginRequest(tcNumber, password,captchaToken);
    
    if (response.data && response.data.token) {
      localStorage.setItem('token', response.data.token);
      return response.data;
    }
    throw new Error('Token not received');
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const logout = async () => {
  try {
    const token = getToken();
    if (token) {
      await logoutRequest(token);
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('userDetails');
  }
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
}; 